import type { LocationByAddressQueryVariables } from './DeliveryLocation.generated';
import { useLocationByAddressQuery } from './DeliveryLocation.generated';
import type { useSearchLocationsByBoundingBoxQuery } from './LocationScreen.searchLocationsByBoundingBox.generated';
import type { useSearchLocationsByStringQuery } from './LocationScreen.searchLocationsByString.generated';
import { useCenterLocations, useLocationsResponse } from './transforms';

// ────────────────────────────────────────────────────────────────────────────────

export const useCenteredLocationsByString = (
  results: ReturnType<typeof useSearchLocationsByStringQuery>[0],
) => {
  const key = 'searchLocationsByString';
  const locations = useLocationsResponse(results, key);

  return useCenterLocations(locations);
};

export const useCenteredLocationsByBoundingBox = (
  results: ReturnType<typeof useSearchLocationsByBoundingBoxQuery>[0],
) => {
  const key = 'searchLocationsByBoundingBox';
  const locations = useLocationsResponse(results, key);

  return useCenterLocations(locations);
};

// ─── LAZY QUERIES ───────────────────────────────────────────────────────────────

export const useLazyLocationByAddress = (
  variables: LocationByAddressQueryVariables,
) => {
  return useLocationByAddressQuery({
    variables,
    pause: true,
  });
};
